import moment from "moment";

const DEFAULT_DATE_FORMAT = "M/DD/YYYY";

export function formatDate(momentDate, format = DEFAULT_DATE_FORMAT) {
  return moment(momentDate).format(format);
}
